var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookedSlotAnonymous(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7643",
    "data-name": "Group 7643",
    transform: "translate(12708 -10190)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22936",
    "data-name": "Ellipse 22936",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(-12708 10190)",
    fill: "#4f5b6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5932",
    "data-name": "Path 5932",
    d: "M6.508,9.52A2.024,2.024,0,0,1,7.975,7.192l.506-.213a1.3,1.3,0,0,0,.951-1.235,1.265,1.265,0,0,0-1.4-1.336A1.5,1.5,0,0,0,6.579,5.938H5A3.036,3.036,0,0,1,8.1,2.77a2.813,2.813,0,0,1,3.036,2.914A2.874,2.874,0,0,1,9.048,8.508c-.587.2-1.012.364-1.012,1.012v.4H6.518Zm-.395,2.722A1.133,1.133,0,0,1,7.267,11.1a1.114,1.114,0,1,1-1.154,1.144Z",
    transform: "translate(-12708.066 10189.957)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookedSlotAnonymous);
export default __webpack_public_path__ + "static/media/booked-slot-anonymous.d33b68f74a6dc1df901fcdffd701c173.svg";
export { ForwardRef as ReactComponent };